import React, { useState,useRef,useEffect } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateTeamShowcaseTabData,teamShowcaseTabData }) => {
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(teamShowcaseTabData.text_align_type);

    //Custom Width
    const [isOpen, setIsOpen] = useState(false);
    const [width, setWidth] = useState(teamShowcaseTabData.layout_custom_width || 1280);
    const [isFullWidth, setIsFullWidth] = useState(Number(teamShowcaseTabData.layout_is_full_width));
    const popupRef = useRef(null);

    //Toggle Popup
    const togglePopup = () => setIsOpen(!isOpen);

    //Handle Width Chnage
    const handleWidthChange = (e) => {
        const newWidth = parseInt(e.target.value, 10);
        setWidth(newWidth);
        updateTeamShowcaseTabData('layout_custom_width', newWidth);
    };

    //Handle full width toggle
    const handleFullWidthToggle = () => {
        const newState = !isFullWidth;
        setIsFullWidth(newState);
        updateTeamShowcaseTabData('layout_is_full_width', newState);
        if (!newState) {
            updateTeamShowcaseTabData('layout_custom_width', width);
        }
    };

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Handle Position Text Alignment change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updateTeamShowcaseTabData("text_align_type", event.target.value);
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Layout</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Text Align</p>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left"} />
                            <div className="card card-body">
                                <div className="content_sub">Left</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center"} />
                            <div className="card card-body">
                                <div className="content_sub">Center</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right"} />
                            <div className="card card-body">
                                <div className="content_sub">Right</div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="customize-width mt-0 position-relative">
                    <div className="onclick-custom-width px-3" onClick={togglePopup}>
                        <span>Width</span>
                        <em>{!isFullWidth ? (width === 'auto' ? 'Auto' : `${width}px`) : 'Full Width'}</em>
                    </div>

                    {isOpen && (
                        <div ref={popupRef} className="width-custom-box width-custom-box-open w-100" style={{bottom: 'auto', top: '50px'}}>
                            <div className="width-custom-inner px-2">
                                <ul>
                                    <li className="">
                                        <h6>Width</h6>
                                        <button className="done-width me-2" onClick={() => setIsOpen(false)}>Done</button>
                                    </li>
                                    <li>
                                        <span>Full Width</span>
                                        <div className="form-group">
                                            <input
                                                type="checkbox"
                                                id="layout_full_width_toggle"
                                                className="chkbx-toggle"
                                                checked={isFullWidth}
                                                onChange={handleFullWidthToggle}
                                            />
                                            <label htmlFor="layout_full_width_toggle"></label>
                                        </div>
                                    </li>
                                    {!isFullWidth && (
                                        <li>
                                            <span>Custom Width</span> <em>{width}px</em>
                                            <div className="slider-container">
                                                <input
                                                    type="range"
                                                    min="250"
                                                    max="1920"
                                                    value={width}
                                                    onChange={handleWidthChange}
                                                />
                                                <div className="value">{width}px</div>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                                <i className="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;